import { render, staticRenderFns } from "./AreasPanel.vue?vue&type=template&id=5df36664&scoped=true&"
import script from "./AreasPanel.vue?vue&type=script&lang=js&"
export * from "./AreasPanel.vue?vue&type=script&lang=js&"
import style0 from "./AreasPanel.vue?vue&type=style&index=0&id=5df36664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df36664",
  null
  
)

export default component.exports